/**
 * Data of an existing request that the backend injects, if the advisor is opened with ?hash=...
 */
export interface ResumeData {
  hasResult?: boolean;
  lastPath?: string | null;
}

/**
 * Returns the url where an existing request (opened via ?hash=...) is continued: the result page if there is a
 * result, otherwise the last step the user has seen.
 *
 * Example: getResumeUrl({hasResult: false, lastPath: '/co2online/moderat/verbrauchsanalyse/heizsystem/2'}, 'mona-moc')
 * returns '/mona-moc/moderat/verbrauchsanalyse/heizsystem/2'
 *
 * @param objectData the request data injected by the backend
 * @param portalId the current portal
 */
export function getResumeUrl(objectData: ResumeData, portalId: string): string {
  const base = '/' + portalId + '/moderat/';
  // requests without the flag hasResult come from an older backend, they were always opened on the result page
  if (objectData?.hasResult !== false) {
    return base + 'sanierung/massnahmen';
  }

  const step = objectData?.lastPath?.match(/\/moderat\/([^?#]+)/)?.[1];
  return base + (step ?? 'einstieg');
}
